import FJEventConstant from "../constant/FJEventConstant";
import FJNetworkStore from "./FJNetworkStore";
import FJMedia from "./FJMedia";
import FJBackgroundStore from "./FJBackgroundStore";
import FJMediaCacheStore from "./FJMediaCacheStore";
import FJCoreConstant from "../core/constant/FJCoreConstant";
import FJMediaStore from "./FJMediaStore";
import FJCloudStore from "./FJCloudStore";

let FJMediaDownloadStore = (function () {
  function createStore() {

    let _mediaMap = new Map();
    return {

      /**
       * @description 返回所有的下载中的资源
       * @return {Map<any, any>}
       */
      get mediaMap() {
        return _mediaMap;
      },

      /**
       * @description 添加/更新资源信息
       * @param sourceId
       * @param progress
       * @param flush
       */
      add: function (sourceId, progress, flush) {
        _mediaMap.set(sourceId, progress);
        if (flush) {
          window.FJEvent.dispatch(FJEventConstant.UPDATE_RESOURCE_DOWNLOAD_DATA);
        } else {
          window.requestIdleCallback(() => {
            if (this.has(sourceId)) {
              window.FJEvent.dispatch(FJEventConstant.UPDATE_RESOURCE_DOWNLOAD_DATA);
            }
          })
        }
      },

      /**
       * @description 移除资源
       * @param sourceId
       * @param flush
       */
      remove: function (sourceId, flush) {
        _mediaMap.delete(sourceId);
        if (flush) {
          window.FJEvent.dispatch(FJEventConstant.UPDATE_RESOURCE_DOWNLOAD_DATA);
        } else {
          window.requestIdleCallback(() => {
            window.FJEvent.dispatch(FJEventConstant.UPDATE_RESOURCE_DOWNLOAD_DATA);
          });
        }
      },

      /**
       * @description 返回指定sourceId的资源下载信息
       * @param sourceId
       * @return {any}
       */
      get: function (sourceId) {
        return _mediaMap.get(sourceId);
      },

      /**
       * @description 是否存在指定sourceId的资源下载信息
       * @param sourceId
       * @return {boolean}
       */
      has: function (sourceId) {
        return _mediaMap.has(sourceId);
      },
    }
  }

  let downloading = createStore();
  let downloadFail = createStore();
  let downloadingCancelFuncMap = new Map();

  /**
   * @description 下载媒体
   * @param sourceId
   * @param url
   * @param options
   * @param options.type
   * @param options.fromType
   * @param options.flush
   * @return {Promise<unknown>}
   */
  function downloadMedia(sourceId, url, options) {
    return new Promise((resolve, reject) => {
    	let rejectFunc = (e) => {
		    downloading.remove(sourceId, options && options.flush);
		    downloadFail.add(sourceId, 0, options && options.flush);
		    reject(e);
	    };
    	let removeCancelFunc = () => {
        if (downloadingCancelFuncMap.has(sourceId)) {
          downloadingCancelFuncMap.delete(sourceId);
        }
      };
      if (downloading.has(sourceId, options && options.flush)) {
        resolve();
      } else {
        downloading.add(sourceId, 0, options && options.flush);
        downloadFail.remove(sourceId, options && options.flush);
        (async () => {
          let {STOCK, SELF, UNSPLASH, LOCAL} = FJMedia.MediaFromType();
          let _url = url;
          if (!_url) {
            let {type, fromType} = options;
            switch (fromType) {
              case STOCK:
                _url = await FJNetworkStore.downloadMedia({id: sourceId, type});
                break;
              case SELF: {
                const {VIDEO, IMAGE, BACKGROUND} = FJCoreConstant;
                let _type = {[VIDEO]: 'video', [IMAGE]: 'image', [BACKGROUND]: 'color'}[type];
                let data = FJBackgroundStore.getUrls(_type, sourceId);
                _url = data && data.url;
                break;
              }
              case UNSPLASH: {
                let data = await FJNetworkStore.getMedia({id: sourceId, type});
                _url = data && data.urls && data.urls.full;
                break;
              }
              case LOCAL: {
                _url = FJCloudStore.getMediaUrlById(sourceId);
                break;
              }
              default:
            }
          }
          let cancelFunc = FJNetworkStore.fetchResource(_url, 'blob', {
            success: (response) => {
              let {name, type, size} = response;
              let updateDownFunc = () => {
                downloading.remove(sourceId, options && options.flush);
                downloadFail.remove(sourceId, options && options.flush);
              };
              FJMediaCacheStore
                .setMediaCache(sourceId, response, {name, type, size})
                .then(cache => {
                  if (FJMediaStore.hasMedia(sourceId) && cache) {
                    let media = FJMediaStore.getMediaById(sourceId);
                    media.setMediaCache(cache);
                    return media.init();
                  }
                })
                .then(() => {
                  if (FJMediaCacheStore.hasMemoryData(sourceId)) {
                    return FJMediaCacheStore.getMinStorageToRelease();
                  } else {
                    return Infinity;
                  }
                })
                .then((restStorage) => {
                  if (size && typeof size === 'number' && size > restStorage) {
                    window.FJEvent.dispatch(FJEventConstant.INDEXEDDB_FULLED);
                  }
                })
                .then(() => {
                  updateDownFunc();
                  resolve();
                })
                .catch(e => {
                  updateDownFunc();
                  reject(e);
                })
                .finally(removeCancelFunc);
            },
            error: (e) => {
              rejectFunc(e);
              removeCancelFunc();
            },
            abort: (e) => {
              rejectFunc(e);
              removeCancelFunc();
            },
            progress: (progress) => {
              downloading.add(sourceId, progress, options && options.flush);
            },
          });
          downloadingCancelFuncMap.set(sourceId, cancelFunc);
        })().catch(rejectFunc);
      }
    })
  }

  /**
   * @description 取消下载媒体
   * @param sourceId
   */
  function cancelMediaDownload(sourceId) {
    let cancelFunc = downloadingCancelFuncMap.get(sourceId);
    if (cancelFunc) cancelFunc();
    downloading.remove(sourceId, true);
    downloadFail.remove(sourceId, true);
    downloadingCancelFuncMap.delete(sourceId);
  }

  return {
    downloading,
    downloadFail,
    downloadMedia,
    cancelMediaDownload,
  }
})();

export default FJMediaDownloadStore;
